import { useState } from 'react';

import AssignmentIcon from '@mui/icons-material/Assignment';
import DoneIcon from '@mui/icons-material/Done';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { green } from '@mui/material/colors';
import IconButton from '@mui/material/IconButton';
import useTheme from '@mui/material/styles/useTheme';
import Tooltip from '@mui/material/Tooltip';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Text from '../text/Text';

const CopyableText = ({ id, label, text, upperCase, iconOnly }) => {
  const { t } = useTranslation();

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  const [copied, setCopy] = useState(false);
  const [tooltipMessage, setTooltipMessage] = useState(
    t('copy', { ns: 'tooltips' })
  );

  const handleClick = () => {
    navigator.clipboard.writeText(text);
    setCopy(true);
    setTooltipMessage(t('copied', { ns: 'tooltips' }));
  };

  return iconOnly ? (
    <Tooltip title={tooltipMessage}>
      <IconButton onClick={handleClick} aria-label="copy text" size="large">
        {copied ? (
          <DoneIcon fontSize="small" sx={{ color: green[500] }} />
        ) : (
          <AssignmentIcon />
        )}
      </IconButton>
    </Tooltip>
  ) : (
    <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
      <Tooltip title={tooltipMessage} placement="right">
        <Button
          id={id}
          size="small"
          variant="text"
          sx={{
            textTransform: upperCase ? 'uppercase' : 'lowercase',
            border: '1px solid lightgray',
          }}
          endIcon={
            copied ? (
              <DoneIcon fontSize="large" sx={{ color: green[500] }} />
            ) : (
              <AssignmentIcon color="disabled" />
            )
          }
          onClick={handleClick}
          color="inherit"
        >
          <Text
            caption
            sx={{
              paddingRight: '0.5em',
              textTransform: 'capitalize',
            }}
          >
            {label}:
          </Text>
          {isSmallScreen ? t('copy', { ns: 'buttons' }) : text}
        </Button>
      </Tooltip>
    </Box>
  );
};

CopyableText.propTypes = {
  id: PropTypes.string,
  text: PropTypes.string,
  label: PropTypes.string,
  upperCase: PropTypes.bool,
  iconOnly: PropTypes.bool,
};

CopyableText.defaultTypes = {
  copied: false,
};

export default CopyableText;
